import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDcXm1NagwCC4xYOBSHl0TLYgqapCrXDoE",
  authDomain: "localbells.firebaseapp.com",
  projectId: "localbells",
  storageBucket: "localbells.firebasestorage.app",
  messagingSenderId: "630556717019",
  appId: "1:630556717019:web:8dd3ee5968bfaa83c181fe",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
